import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";

import React from "react";

import { isRosterExist } from "@/fetch/fetchRoster";
import { getAllPromoter } from "@/fetch/fetchStaff";
import { getAllStreet } from "@/fetch/fetchWork";
import getDateRange from "@/lib/getDateRange";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useParams } from "react-router-dom";

import _ from "lodash";
import moment from "moment";
export default function RosterUserDialog(props) {
  const {
    onCancel,
    open,
    onSubmit,
    submitMessage,
    cancelMessage,
    deleteMessage = "刪除",
    onDelete,
    actions,
    event,
    handleOnChange,
    handleOnUserChange,
    submitButtonColor = "primary",
  } = props;
  const [options, setOptions] = React.useState([]);
  const [endDateOpen, setEndDateOpen] = React.useState(false);
  const { date, location_id } = useParams();
  const [streetOptions, setStreetOptions] = React.useState([]);

  const rosters = [
    {
      label: "全日更",
      value: "FULL",
    },
    {
      label: "A更",
      value: "A",
    },
    {
      label: "B更",
      value: "B",
    },
  ];
  const checkIsRosterExist = async (field, value, callback = () => {}) => {
    const user_id = field === "user_id" ? value : event.user_id;
    const start_date = moment(
      field === "start_date" ? value : event.start_date
    ).format("YYYY-MM-DD");
    const end_date = moment(
      field === "end_date" ? value : event.end_date
    ).format("YYYY-MM-DD");
    const dateRange = getDateRange(start_date, end_date);
    const rosterExist = await isRosterExist(user_id, dateRange);
    if (rosterExist.data.length > 0) {
      const { data } = rosterExist;
      const { name, is_off, is_leave } = data[0];
      if (!is_off && !is_leave) {
        const timeSlot = _.map(
          data,
          (d) =>
            `${d.work_name}(${d.work_shortcode}) - ${moment(d.date).format(
              "YYYY-MM-DD"
            )}`
        );
        const answer = window.confirm(
          `${name}於以下時間有更期\n${timeSlot.join(
            "\n"
          )} \n要確定繼續並取代以上更期嗎`
        );
        if (answer) {
          callback();
        } else {
          handleOnUserChange(event);
        }
      } else {
        handleOnUserChange({
          ...event,
          date: moment(event.start_date).format("YYYY-MM-DD"),
          location_id: location_id,
          user_id: user_id,
          time_checkedin: data[0].time_checkedin,
          time_checkedout: data[0].time_checkedout,
        });
      }
    } else {
      callback();
    }
  };
  const fetch = async () => {
    const promoters = await getAllPromoter(true);
    const streets = await getAllStreet();

    const formattedOptions = _.map(promoters.data, (promoter) => {
      return {
        label: `${promoter.staff_code} - ${promoter.full_name}`,
        value: String(promoter.id),
      };
    });
    const formattedStreetsOptions = _.map(streets.data, (s) => {
      return {
        label: `${s.street}`,
        value: s.street,
      };
    });
    setStreetOptions(formattedStreetsOptions);
    setOptions([...formattedOptions]);
  };
  React.useEffect(() => {
    fetch();
  }, []);
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle>{event.title ? event.start_date : ""}</DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <DialogContentText>
          <Box
            component="form"
            noValidate
            sx={{
              display: "grid",
              gridTemplateColumns: { sm: "1fr 1fr" },
              gap: 2,
            }}
          >
            {!event.title && (
              <>
                <FormControl fullWidth>
                  <DatePicker
                    required
                    disabled={event.id || !actions?.update}
                    closeOnSelect={true}
                    id="startDate"
                    name="startDate"
                    label="開始日期"
                    minDate={moment(date, "YYYY-M").startOf("month")}
                    maxDate={moment(date, "YYYY-M").endOf("month")}
                    value={event.start_date}
                    onChange={async (value) => {
                      await checkIsRosterExist(
                        "start_date",
                        value,
                        handleOnChange(value, "start_date")
                      );
                      setEndDateOpen(true);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} sx={{ width: "100%" }} />
                    )}
                  ></DatePicker>
                </FormControl>
                <FormControl fullWidth>
                  <DatePicker
                    open={endDateOpen}
                    disabled={event.id || !actions?.update}
                    onOpen={() => setEndDateOpen(true)}
                    onClose={() => setEndDateOpen(false)}
                    closeOnSelect={true}
                    required
                    id="endDate"
                    name="endDate"
                    label="結束日期"
                    minDate={event.start_date}
                    maxDate={moment(date, "YYYY-M").endOf("month")}
                    value={event.end_date}
                    onChange={async (value) => {
                      await checkIsRosterExist(
                        "end_date",
                        value,
                        handleOnChange(value, "end_date")
                      );
                      setEndDateOpen(false);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} sx={{ width: "100%" }} />
                    )}
                  ></DatePicker>
                </FormControl>
              </>
            )}
            <FormControl fullWidth>
              <Autocomplete
                required
                disabled={event.id || !actions?.update}
                id="combo-box-demo"
                options={options}
                groupBy={(option) => option.category}
                label="員工"
                value={
                  options.find(
                    (option) =>
                      parseInt(option.value) === parseInt(event.user_id)
                  ) || null
                }
                onChange={async (e, newValue) => {
                  let newFormValue = {};
                  newFormValue = {
                    is_off: false,
                    is_leave: false,
                    leave_type: null,
                    user_id: newValue.value,
                    value: newValue.value,
                  };
                  await checkIsRosterExist(
                    "user_id",
                    newValue.value,
                    handleOnUserChange(newFormValue)
                  );
                }}
                renderInput={(params) => <TextField {...params} label="員工" />}
              />
            </FormControl>
            {!event.is_leave && !event.is_off && (
              <FormControl fullWidth>
                <Grid container spacing={2}>
                  <Grid size={6}>
                    <Autocomplete
                      disabled={!actions?.update}
                      required
                      id="combo-box-demo"
                      options={rosters}
                      value={rosters.find(
                        (roster) => roster.value === event.roster_value
                      )}
                      onChange={(event, newValue) => {
                        handleOnChange(newValue.value, "roster_value");
                      }}
                      label="Roster"
                      renderInput={(params) => (
                        <TextField {...params} label="Roster" />
                      )}
                    />
                  </Grid>
                  <Grid size={6}>
                    <Autocomplete
                      freeSolo
                      required
                      disabled={!actions?.update}
                      id="street"
                      options={streetOptions}
                      value={streetOptions.find(
                        (roster) => roster.value === event.street
                      )}
                      onChange={(event, newValue) => {
                        handleOnChange(newValue.value, "street");
                      }}
                      label="street"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="街"
                          onChange={(e) => {
                            handleOnChange(e?.target?.value, "street");
                          }}
                        />
                      )}
                      xs={6}
                    />
                  </Grid>
                </Grid>
              </FormControl>
            )}
          </Box>
        </DialogContentText>
      </DialogContent>
      {actions?.update && (
        <DialogActions>
          <Button onClick={onCancel}>{cancelMessage}</Button>
          {event.user_id && (
            <Button onClick={onDelete} color={"error"} type="submit">
              {deleteMessage}
            </Button>
          )}
          <Button onClick={onSubmit} color={submitButtonColor} type="submit">
            {submitMessage}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
